import React from 'react';
import { Calendar } from 'lucide-react';
import { FinanceiroGrafico } from './index';

const ContasPagamentoSection = ({ dadosContasPagamento }) => {
  return (
    <div className="overflow-hidden">
      <div className="pt-6 sm:pt-3 pb-2">
        <div className="flex items-center justify-between mb-4 min-w-0">
          <h3 className="text-lg font-semibold text-[color:var(--text-primary)] flex items-center min-w-0 flex-1">
            <Calendar className="h-5 w-5 text-emerald-600 mr-2 flex-shrink-0" />
            <span className="truncate">Contas a Pagar por Dia</span>
          </h3>
        </div>
        <p className="text-sm text-[color:var(--text-muted)] mb-6">Distribuição de contas a pagar por dia da semana</p>
        
        <div className="overflow-hidden">
          <FinanceiroGrafico
            tipo="bar"
            dados={dadosContasPagamento}
            altura="h-80"
          />
        </div>
      </div>
    </div>
  );
};

export default ContasPagamentoSection;


